import { createApi } from '@reduxjs/toolkit/query/react'
import { DELETE_CLIENT_CHATTER, LIST_CLIENT_CHATTER, CREATE_CLIENT_CHATTER, VIEW_CLIENT_CHATTER, EDIT_CLIENT_CHATTER, ARCHIVE_CLIENT_CHATTER, CHATTER_CLIENT_PROGRAMS_LIST, CHATTER_ATTENDANCE_LIST, FAVOURITE_CHATTER_CLIENT, CHATTER_CLIENT_ATTENDANCE_LIST } from "config/apiPaths"
import { RTK_CACHE_EXPIRATION } from "config/constants";
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const clientChatterApi = createApi({
    reducerPath: 'chatterApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/client/chatter",
    }),
    tagTypes: ["ClientChatterApi", "ClientChatterDetails"],
    keepUnusedDataFor: RTK_CACHE_EXPIRATION,
    endpoints: (builder) => ({

        // get home education list
        getClientChatterList: builder.query({
            query: ({ search = "", therapist_id = "", status = "", page = 1, limit = 10, funding_source = "", program_id = "", sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: LIST_CLIENT_CHATTER,
                data: { search, therapist_id, status: status?.value ? status?.value : "", page, limit, sort, funding_source: funding_source?.value ? funding_source?.value : "", program_id: program_id?.value ? program_id?.value : "" }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ClientChatterApi"]
        }),

        // delete client chatter
        deleteClientChatter: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${DELETE_CLIENT_CHATTER}/${id}`
            }),
            invalidatesTags: ["ClientChatterApi", "ClientChatterDetails"]
        }),

        // create client chatter
        createClientChatter: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: CREATE_CLIENT_CHATTER,
                data
            }),
            invalidatesTags: ["ClientChatterApi"]
        }),

        // chatter client details
        chatterClientDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${VIEW_CLIENT_CHATTER}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ClientChatterDetails"]
        }),

        // update chatter client
        updateChatterClient: builder.mutation({
            query: ({ data, clientId }) => ({
                method: "PUT",
                url: `${EDIT_CLIENT_CHATTER}/${clientId}`,
                data
            }),
            invalidatesTags: ["ClientChatterApi", "ClientChatterDetails"]
        }),

        // archive client chatter
        archiveClientChatter: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${ARCHIVE_CLIENT_CHATTER}/${id}`
            }),
            invalidatesTags: ["ClientChatterApi", "ClientChatterDetails"]
        }),

        getChatterClientProgramsList: builder.query({
            // query: ({ search = "", status = "", page = 1, limit = 10, funding_source = "", program_id = "", sort = { column: "id", direction: "ASC" } }) => ({
            query: ({ clientId }) => ({
                method: "GET",
                url: `${CHATTER_CLIENT_PROGRAMS_LIST}/${clientId}`,
                // data: { search, status, page, limit, sort, funding_source, program_id }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ClientChatterPrograms"]
        }),

        getChatterClientAttendanceList: builder.query({
            query: ({ programId, clientId }) => ({
                method: "GET",
                url: `${CHATTER_ATTENDANCE_LIST}/${programId}/${clientId}`,
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ClientChatterPrograms"]
        }),

        favouriteChatterClient: builder.mutation({
            query: ({ data, id }) => ({
                method: "PATCH",
                url: `${FAVOURITE_CHATTER_CLIENT}/${id}`,
                data
            }),
            invalidatesTags: ["SchoolClients", "SchoolClientDetails"]
        }),

        getChatterClientAttendance: builder.query({
            query: ({ clientId }) => ({
                method: "PATCH",
                url: `${CHATTER_CLIENT_ATTENDANCE_LIST}/${clientId}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterClientAttendance"]
        }),
    }),
})

export const {
    useGetClientChatterListQuery,
    useDeleteClientChatterMutation,
    useCreateClientChatterMutation,
    useChatterClientDetailsQuery,
    useUpdateChatterClientMutation,
    useArchiveClientChatterMutation,
    useLazyChatterClientDetailsQuery,
    useGetChatterClientProgramsListQuery,
    useLazyGetChatterClientAttendanceListQuery,
    useFavouriteChatterClientMutation,
    useGetChatterClientAttendanceQuery

} = clientChatterApi;